import {
  START_ROUTE_LOADING,
  FINISH_ROUTE_LOADING,
  START_API_LOADING,
  FINISH_API_LOADING,
  CLEAR_API_LOADING
} from "src/vuex/mutationTypes";
import router from "src/http/router";

const defaultState = {
  navigationLoading: false,
  apiLoading: false,
  ongoingRequests: {},
  pageTitle: 'Integra Cargo',
};

const actions = {
  loadingStart() {
    if (this._vm) {
      document.documentElement.style.cursor = "progress";
      this._vm.$Progress.start();
    }
  },
  loadingFinish() {
    if (this._vm) {
      document.documentElement.style.cursor = "default";
      this._vm.$Progress.finish();
    }
  },
  loadingError() {
    if (this._vm) {
      document.documentElement.style.cursor = "default";
      this._vm.$Progress.fail();
    }
  },

  startRouteLoading({ commit, getters }) {
    if (getters.isLoading === false) {
      this.dispatch("loadingStart");
    }

    commit(START_ROUTE_LOADING);
  },
  finishRouteLoading({ commit, getters }) {
    commit(FINISH_ROUTE_LOADING);
    let that = this;

    setTimeout(() => {
      if (getters.isLoading === false) {
        that.dispatch("loadingFinish");
      }
    }, 300);
  },
  startApiLoading({ commit, getters }, uuid) {
    this.dispatch("loadingStart");

    commit(START_API_LOADING, uuid);
  },
  finishApiLoading({ commit, getters }, uuid) {
    commit(FINISH_API_LOADING, uuid);

    if (getters.isLoading === false) {
      this.dispatch("loadingFinish");
    }
  },
  finishLoadingWithError(context) {
    context.commit(CLEAR_API_LOADING);
    this.dispatch("loadingError");
  }
};
const mutations = {
  [START_ROUTE_LOADING]: state => {
    state.navigationLoading = true;
  },
  [FINISH_ROUTE_LOADING]: state => {
    state.navigationLoading = false;
  },
  [START_API_LOADING]: (state, uuid) => {
    state.apiLoading = true;

    state.ongoingRequests[uuid] = {
      origin: router.currentRoute.path
    };
  },
  [FINISH_API_LOADING]: (state, uuid) => {
    delete state.ongoingRequests[uuid];

    if (Object.values(state.ongoingRequests).length === 0) {
      state.apiLoading = false;
    }
  },
  [CLEAR_API_LOADING]: state => {
    state.apiLoading = false;
    state.ongoingRequests = [];
  },
  pageTitle (state, pageTitle) {
    let title = 'Integra Cargo';

    if (pageTitle > 0)
      title = `Integra Cargo (${pageTitle})`;

    document.title = title;
    state.pageTitle = title;
  }
};

const getters = {
  isNavigationLoading: state => state.navigationLoading,
  isApiLoading: state => state.apiLoading,
  isLoading: state => state.navigationLoading || state.apiLoading,
  getOngoingRequests: state => state.ongoingRequests
};

export default {
  state: defaultState,
  getters,
  actions,
  mutations
};
